// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"f6c18638","455":"7cf7e463","977":"d2b9f683"}[chunkId] + ".chunk.js";
};